/* BlankApparel — warehouse selector UI (picker sheet opened from the product page, quick order stock, cart note).
   The selected warehouse itself lives in BA.wh (assets/ba.js); this file only reacts to it. */
(function () {
  'use strict';
  function boot() {
    var BA = window.BA;
    if (!BA || !BA.wh) return;
    var fmt = BA.fmt;
    var sheet = document.querySelector('[data-ba-wh-sheet]');
    var lastFocus = null;

    /* ---------- Labels everywhere ---------- */
    function labels() {
      var c = BA.city(BA.wh.get());
      document.querySelectorAll('[data-ba-wh-name]').forEach(function (e) { e.textContent = c.name; });
      document.querySelectorAll('[data-ba-wh-code]').forEach(function (e) { e.textContent = c.code; });
      if (sheet) {
        sheet.querySelectorAll('[data-wh]').forEach(function (o) {
          var on = o.getAttribute('data-wh') === c.col;
          o.classList.toggle('is-active', on); o.setAttribute('aria-checked', on ? 'true' : 'false');
          if (on) {
            var dir = sheet.querySelector('[data-ba-wh-dir]');
            if (dir) dir.href = 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent('BlankApparel ' + o.getAttribute('data-addr'));
          }
        });
      }
    }

    /* ---------- Sheet ---------- */
    function open() {
      if (!sheet) return;
      lastFocus = document.activeElement;
      labels();
      sheet.hidden = false;
      requestAnimationFrame(function () { sheet.classList.add('is-open'); });
      document.documentElement.classList.add('ba-lock');
      var cur = sheet.querySelector('.ba-whs__opt.is-active') || sheet.querySelector('.ba-whs__opt');
      if (cur) cur.focus();
    }
    function close() {
      if (!sheet || sheet.hidden) return;
      sheet.classList.remove('is-open');
      document.documentElement.classList.remove('ba-lock');
      setTimeout(function () { sheet.hidden = true; }, 220);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    BA.openWh = open;
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-ba-wh-open]')) { e.preventDefault(); if (BA.closeMenu) BA.closeMenu(); open(); return; }
      if (e.target.closest('[data-ba-wh-close]')) { close(); return; }
      var o = e.target.closest('.ba-whs__opt');
      if (o) { BA.wh.set(o.getAttribute('data-wh')); setTimeout(close, 160); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    /* ---------- Toast on change ---------- */
    var toast;
    function say(t) {
      if (!toast) { toast = document.createElement('div'); toast.className = 'ba ba-whtoast'; toast.setAttribute('role', 'status'); document.body.appendChild(toast); }
      toast.textContent = t; toast.classList.add('is-in');
      clearTimeout(toast.__t); toast.__t = setTimeout(function () { toast.classList.remove('is-in'); }, 2400);
    }

    /* ---------- Cart remembers the warehouse (shows on the order as "Warehouse") ---------- */
    var cartBusy = null;
    BA.whCart = function () {
      if (cartBusy) return cartBusy;
      var name = BA.city(BA.wh.get()).name;
      cartBusy = fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          if (!c.item_count || (c.attributes && c.attributes.Warehouse === name)) return;
          return fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: { Warehouse: name } }) });
        })
        .catch(function () {})
        .then(function () { cartBusy = null; });
      return cartBusy;
    };
    var of = window.fetch;
    window.fetch = function (u) {
      var p = of.apply(this, arguments);
      try {
        var url = typeof u === 'string' ? u : (u && u.url) || '';
        if (/\/cart\/add(\.js)?(\?|$)/.test(url)) p.then(function (r) { if (r.ok) setTimeout(BA.whCart, 80); }, function () {});
      } catch (e) {}
      return p;
    };

    /* ---------- Quick order grid: warehouse stock per size ---------- */
    function initQuickOrder() {
      var qo = document.querySelector('.ba-qo[data-stock-url]');
      if (!qo) return;
      var url = qo.getAttribute('data-stock-url');
      var inputs = [].slice.call(qo.querySelectorAll('input[data-id]'));
      if (!url || !inputs.length) return;
      var data = {}, loaded = false;
      var st = qo.querySelector('[data-qo-wh-status]');
      inputs.forEach(function (i) { i.setAttribute('data-max0', i.max || '9999'); });
      function paint() {
        if (!loaded) return;
        var wh = BA.wh.get(), city = BA.city(wh), missing = 0;
        inputs.forEach(function (i) {
          var lab = i.closest('.ba-qo__size');
          var raw = data[i.getAttribute('data-id')];
          var tag = lab.querySelector('.ba-qo__wh');
          if (!tag) { tag = document.createElement('small'); tag.className = 'ba-qo__wh'; lab.appendChild(tag); }
          var left = lab.querySelector('.ba-qo__left'); if (left) left.hidden = !!raw;
          if (!raw) { tag.textContent = ''; i.disabled = false; i.max = i.getAttribute('data-max0'); lab.classList.remove('is-nothere'); return; }
          var p = BA.parseStock(raw), n = p[wh];
          var mx = Math.min(parseInt(i.getAttribute('data-max0'), 10) || 9999, n);
          i.max = mx; i.disabled = mx <= 0;
          if ((parseInt(i.value, 10) || 0) > mx) { i.value = mx > 0 ? mx : ''; i.dispatchEvent(new Event('input', { bubbles: true })); }
          lab.classList.toggle('is-nothere', n <= 0);
          tag.classList.toggle('is-low', n > 0 && n <= 10);
          if (n > 0) { tag.innerHTML = fmt(n) + ' at ' + city.code; }
          else {
            var alt = BA.altWh(p, wh);
            missing++;
            tag.textContent = alt ? 'In ' + alt.city.code + ' (' + fmt(alt.n) + ')' : 'Out';
          }
        });
        if (st) st.textContent = missing ? 'Some sizes are only at another warehouse. Change the warehouse on the product page to order them.' : '';
      }
      BA.wh.on(paint);
      var ids = inputs.map(function (i) { return i.getAttribute('data-id'); });
      var chunks = [];
      for (var k = 0; k < ids.length; k += 60) chunks.push(ids.slice(k, k + 60));
      if (st) st.textContent = 'Loading warehouse stock…';
      Promise.all(chunks.map(function (c) { return BA.fetchStock(url, c).then(function (d) { Object.keys(d).forEach(function (id) { data[id] = d[id]; }); }, function () {}); }))
        .then(function () { loaded = Object.keys(data).length > 0; if (st) st.textContent = loaded ? '' : "Couldn't load warehouse stock right now."; paint(); });
    }

    BA.wh.on(function (wh) { labels(); say('Showing ' + BA.city(wh).name + ' stock'); BA.whCart(); });
    labels();
    initQuickOrder();
    BA.whCart();
    document.addEventListener('shopify:section:load', labels);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
